import { AppBar, Box, Button, Modal, Toolbar, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { TbLogout } from "react-icons/tb";
import { useState } from "react";

export default function Header() {
  const [modalOpen, setmodalOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const cookies = new Cookies();

  const currentRole = cookies.get("hts-role");
  const token = cookies.get("hts-tok");
  console.log("token=", token);
  console.log("Current Role - ", currentRole);

  const handleLogout = () => {
    setmodalOpen(true);
  };

  const handleCloseModal = () => {
    setmodalOpen(false);
  };

  const handleLogoutConfirm = () => {
    setmodalOpen(false);
    cookies.remove("hts-tok");
    cookies.remove("hts-role");
    navigate("/home");
    window.location.reload();
  };

  return (
    <Box sx={{ p: 4, m: 0 }}>
      <AppBar
        position="fixed"
        sx={{ background: "white", width: "100%", height: "63.5px" }}
      >
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            <img
              src="/Logo.svg"
              alt="Logo"
              style={{ height: "20px", verticalAlign: "middle" }}
            />
          </Typography>

          {!token && (
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#00A9CE",
                color: "white",
                borderRadius: "16px",
                font: "Inter",
              }}
              onClick={() => navigate("/login")}
            >
              Login
            </Button>
          )}
          {location.pathname !== "/chapters" && currentRole === "HTS_ADMIN" && (
            <>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#00A9CE",
                  color: "white",
                  borderRadius: "16px",
                  font: "Inter",
                }}
                onClick={() => navigate("/chapters")}
              >
                Upload HTS
              </Button>
            </>
          )}
          {token && (
            <TbLogout
              style={{ color: "#dc2f02", cursor: "pointer", marginLeft: 20 }}
              size={25}
              onClick={handleLogout}
              className="logout-hover-animate"
            />
          )}
        </Toolbar>
      </AppBar>
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" fontWeight={"bold"} sx={{ mb: 0.5 }}>
              Logout Confirmation
            </Typography>
            <Typography variant="subtitle2" sx={{ color: "#2b2d42" }}>
              Are you sure you want to do logout ?
            </Typography>
            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              <Button
                variant="contained"
                sx={{
                  pt: 0.6,
                  backgroundColor: "#00A9CE",
                  color: "white",
                  borderRadius: "10px",
                  font: "Inter",
                  fontSize: 13,
                }}
                onClick={() => handleLogoutConfirm()}
              >
                Confirm
              </Button>
              <Button
                variant="contained"
                sx={{
                  pt: 0.6,
                  backgroundColor: "white",
                  color: "#00A9CE",
                  borderRadius: "10px",
                  font: "Inter",
                  border: "1px solid #00A9CE",
                  fontSize: 13,
                }}
                onClick={() => handleCloseModal()}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
